import axios from "axios";
// axios.defaults.baseURL = "http://192.168.109.4:8888/zp";
// axios.defaults.baseURL = "http://192.168.100.56:8888/zp";
axios.interceptors.response.use(res => {
    return res.data;
})

export let addResume = params => {
    return axios.post(`/api/web/resumeManager/resume/insertResume`, params);
};

export const getRecruitList = params => {
    return axios.post(`/api/web/recruitManager/recruit/conditions`, params);
};

export const getRecruitDetail = params => {
    return axios.get(`/api/web/recruitManager/recruit/detail?guid=${params}`);
};

export const getMajorList = () => {
    return axios.get(`/api/web/jobManager/job/jobsByParentCode`);
};
